/* eslint-disable */
// GENERATED FILE - DO NOT EDIT
import React, { SVGProps } from "react";

const SvgTeachingEducationAndTraining = (props: SVGProps<SVGSVGElement>) => (
  <svg width={29.175} viewBox="0 0 29.175 29.487" {...props}>
    <g data-name="Teaching, Education and Training">
      <g data-name="Group 329">
        <g data-name="Group 326" transform="translate(.399 .446)">
          <path
            data-name="Path 1013"
            d="M23.713 23.882H4.664a.748.748 0 01-.748-.748v-6.937a.748.748 0 01.748-.748h19.049a.748.748 0 01.748.748v6.937a.748.748 0 01-.748.748z"
            fill="#12b05e"
          />
          <path
            data-name="Path 1014"
            d="M23.713 15.444h-1.958a.748.748 0 01.748.748v6.937a.748.748 0 01-.748.748h1.958a.748.748 0 00.748-.748v-6.937a.748.748 0 00-.748-.748z"
            fill="#03984b"
          />
          <path
            data-name="Path 1015"
            d="M17.207 4.8h1.333V2.679A1.977 1.977 0 0016.563.702h-.7v2.75A1.348 1.348 0 0017.207 4.8z"
            fill="#a74b30"
          />
          <path
            data-name="Path 1016"
            d="M17.207 4.8h1.333V2.679A1.977 1.977 0 0016.563.702h-.7v2.75A1.348 1.348 0 0017.207 4.8z"
            fill="#a74b30"
          />
          <path
            data-name="Path 1017"
            d="M11.497 11.159h-.463a1.58 1.58 0 00-1.58 1.58v2.71h9.478v-2.706a1.58 1.58 0 00-1.58-1.58z"
            fill="#d5e3f4"
          />
          <path
            data-name="Path 1018"
            d="M14.183 12.603a1.459 1.459 0 01-1.459-1.459V8.116h2.92v3.029a1.459 1.459 0 01-1.461 1.458z"
            fill="#ffbfb1"
          />
          <path
            data-name="Path 1019"
            d="M17.703 4.798h-.049a3.521 3.521 0 00-6.943 0h-.049a1.2 1.2 0 000 2.391h.049a3.521 3.521 0 006.943 0h.049a1.2 1.2 0 100-2.391z"
            fill="#ffcebf"
          />
          <path
            data-name="Path 1020"
            d="M17.704 4.798h-.049a3.523 3.523 0 00-3.961-2.9 3.522 3.522 0 012.982 2.9h.049a1.2 1.2 0 110 2.391h-.049a3.523 3.523 0 01-2.982 2.9 3.523 3.523 0 003.961-2.9h.049a1.2 1.2 0 100-2.391z"
            fill="#ffbfb1"
          />
          <path
            data-name="Path 1021"
            d="M14.824 0h-5v3.215A1.585 1.585 0 0011.409 4.8h3.92a1.49 1.49 0 001.49-1.49V1.995A2 2 0 0014.824 0z"
            fill="#c4573a"
          />
          <path
            data-name="Path 1022"
            d="M14.821 0h-1.468a2 2 0 012 2v1.314a1.49 1.49 0 01-1.49 1.49h1.468a1.49 1.49 0 001.49-1.49V1.995a2 2 0 00-2-2z"
            fill="#a74b30"
          />
          <path
            data-name="Path 1023"
            d="M10.925 12.603h6.515v2.846h-6.515z"
            fill="#fff"
          />
          <circle
            data-name="Ellipse 73"
            cx={2.721}
            cy={2.721}
            r={2.721}
            transform="translate(1.124 20.456)"
            fill="#ffcebf"
          />
          <path
            data-name="Path 1024"
            d="M7.699 28.623h-7.7a2.73 2.73 0 012.73-2.73h2.24a2.73 2.73 0 012.73 2.73z"
            fill="#ffcd27"
          />
          <circle
            data-name="Ellipse 74"
            cx={2.721}
            cy={2.721}
            r={2.721}
            transform="translate(11.565 20.456)"
            fill="#ffcebf"
          />
          <path
            data-name="Path 1025"
            d="M18.14 28.623h-7.7a2.73 2.73 0 012.73-2.73h2.24a2.73 2.73 0 012.73 2.73z"
            fill="#ffcd27"
          />
          <circle
            data-name="Ellipse 75"
            cx={2.721}
            cy={2.721}
            r={2.721}
            transform="translate(21.736 20.456)"
            fill="#ffcebf"
          />
          <g data-name="Group 324" fill="#ffcd27">
            <path
              data-name="Path 1026"
              d="M28.311 28.624h-7.7a2.73 2.73 0 012.73-2.73h2.24a2.73 2.73 0 012.73 2.73z"
            />
            <path
              data-name="Path 1027"
              d="M14.707 18.674h-1.036a.777.777 0 110-1.554h1.036a.777.777 0 110 1.554z"
            />
            <path
              data-name="Path 1028"
              d="M8.181 18.674H7.145a.777.777 0 010-1.554h1.036a.777.777 0 110 1.554z"
            />
            <path
              data-name="Path 1029"
              d="M21.233 18.674h-1.038a.777.777 0 110-1.554h1.036a.777.777 0 010 1.554z"
            />
          </g>
          <g data-name="Group 325">
            <path
              data-name="Path 1030"
              d="M17.441 11.162v4.287h1.486v-2.71a1.58 1.58 0 00-1.486-1.577z"
              fill="#b3dafe"
            />
          </g>
          <path
            data-name="Path 1031"
            d="M3.846 20.456a2.723 2.723 0 00-.653.079 2.721 2.721 0 010 5.283 2.721 2.721 0 10.653-5.363z"
            fill="#ffbfb1"
          />
          <path
            data-name="Path 1032"
            d="M4.969 25.893H3.664a2.73 2.73 0 012.73 2.73h1.304a2.73 2.73 0 00-2.729-2.73z"
            fill="#deaa00"
          />
          <path
            data-name="Path 1033"
            d="M14.287 20.456a2.723 2.723 0 00-.653.079 2.721 2.721 0 010 5.283 2.721 2.721 0 10.653-5.363z"
            fill="#ffbfb1"
          />
          <path
            data-name="Path 1034"
            d="M15.41 25.893h-1.305a2.73 2.73 0 012.73 2.73h1.305a2.73 2.73 0 00-2.73-2.73z"
            fill="#deaa00"
          />
          <path
            data-name="Path 1035"
            d="M24.457 20.456a2.723 2.723 0 00-.653.079 2.721 2.721 0 010 5.283 2.721 2.721 0 10.653-5.363z"
            fill="#ffbfb1"
          />
          <path
            data-name="Path 1036"
            d="M25.581 25.893h-1.305a2.73 2.73 0 012.73 2.73h1.305a2.73 2.73 0 00-2.73-2.73z"
            fill="#deaa00"
          />
        </g>
        <g data-name="Group 327">
          <path
            data-name="Path 1037"
            d="M17.097 8.19h-.487a.311.311 0 010-.621h.487a.311.311 0 010 .621z"
            fill="#ffb09e"
          />
        </g>
        <g data-name="Group 328">
          <path
            data-name="Path 1038"
            d="M12.553 8.19h-.487a.311.311 0 010-.621h.487a.311.311 0 010 .621z"
            fill="#ffb09e"
          />
        </g>
      </g>
      <g data-name="Group 330">
        <path
          data-name="Path 1039"
          d="M13.329 7.005v-.648a.432.432 0 00-.864 0v.648a.432.432 0 10.864 0z"
        />
        <path
          data-name="Path 1040"
          d="M16.333 7.438a.432.432 0 00.432-.432v-.648a.432.432 0 10-.864 0v.648a.432.432 0 00.432.432z"
        />
        <path
          data-name="Path 1041"
          d="M14.614 9.285a1.181 1.181 0 001.18-1.18.432.432 0 10-.864 0 .316.316 0 11-.631 0 .432.432 0 10-.864 0 1.181 1.181 0 001.179 1.18z"
        />
        <path
          data-name="Path 1042"
          d="M26.912 26.024a3.151 3.151 0 00-1.587-5.538v-3.857a1.181 1.181 0 00-1.18-1.18h-4.357v-.381a.432.432 0 00-.864 0v.381h-.623v-2.414a.432.432 0 00-.432-.432v-.576a1.152 1.152 0 011.051 1.057.432.432 0 00.862-.064 2.02 2.02 0 00-2.006-1.861h-1.271v-.649a3.932 3.932 0 001.937-2.486 1.626 1.626 0 00.938-2.645.429.429 0 00.026-.147V3.111A2.41 2.41 0 0016.961.7a2.419 2.419 0 00-1.706-.7h-5a.432.432 0 00-.432.432v3.215a2.008 2.008 0 00.512 1.34 1.627 1.627 0 00.453 3.037 3.932 3.932 0 001.937 2.486v.649h-1.263a2.014 2.014 0 00-2.012 2.012v2.278H5.096a1.181 1.181 0 00-1.18 1.18v.681a.432.432 0 00.864 0v-.681a.317.317 0 01.316-.316h19.049a.317.317 0 01.316.316v3.855a3.159 3.159 0 00-2.713 3.4h-3.889c.007-.081.012-.187.012-.274a3.153 3.153 0 10-6.306 0c0 .091.006.2.012.274H7.418a3.059 3.059 0 00.005-.472A3.151 3.151 0 004.78 20.5v-1.17a.432.432 0 10-.864 0v1.151a3.151 3.151 0 00-1.66 5.549A3.167 3.167 0 000 29.059a.432.432 0 00.432.432h7.7a.432.432 0 00.432-.432 3.167 3.167 0 00-2.263-3.031 3.166 3.166 0 00.916-1.278h4.561a3.166 3.166 0 00.918 1.28 3.167 3.167 0 00-2.256 3.029.432.432 0 00.432.432h7.7a.432.432 0 00.432-.432 3.167 3.167 0 00-2.263-3.031 3.167 3.167 0 00.916-1.278h4.291a3.166 3.166 0 00.918 1.28 3.167 3.167 0 00-2.256 3.029.432.432 0 00.432.432h7.7a.432.432 0 00.432-.432 3.167 3.167 0 00-2.263-3.031zm-10.46-14h.557v.58h-.808a1.877 1.877 0 00.251-.581zm2.091-8.912V4.8h-.108a3.948 3.948 0 00-.752-1.474 4.825 4.825 0 00-.119-1.648 1.547 1.547 0 01.978 1.433zM10.688.864h4.568a1.566 1.566 0 011.509 1.154 7.014 7.014 0 01.055 1.723A1.06 1.06 0 0115.76 4.8h-3.92a1.155 1.155 0 01-1.152-1.153V.864zm.882 6.685a.432.432 0 00-.443-.36.763.763 0 11-.031-1.526.449.449 0 00.265-.056 2.115 2.115 0 00.481.058h3.92a1.93 1.93 0 001.705-1.035 3.075 3.075 0 01.2.675.447.447 0 00.5.361.763.763 0 11-.056 1.525.434.434 0 00-.443.36 3.078 3.078 0 01-3.045 2.575 3.079 3.079 0 01-3.046-2.575zm3.046 3.439a4.037 4.037 0 001.027-.134v.724a1.027 1.027 0 01-2.053 0v-.724a4.03 4.03 0 001.025.133zm-2.394 1.036h.557a1.881 1.881 0 00.251.58h-.808v-.58zm-1.907 1.148a1.149 1.149 0 011.043-1.143v.571a.432.432 0 00-.432.432v2.414h-.612zm1.473 2.277v-1.982h5.652v1.982zm-9.8 8.16a2.29 2.29 0 012.345-2.288 2.288 2.288 0 01.076 4.572h-.267a2.292 2.292 0 01-2.154-2.284zm3.413 3.149a2.3 2.3 0 012.257 1.866H.905a2.3 2.3 0 012.257-1.866zm9.317-5.438a2.289 2.289 0 01.136 4.574h-.271a2.289 2.289 0 01.136-4.574zm1.124 5.438a2.3 2.3 0 012.257 1.866h-6.754a2.3 2.3 0 012.257-1.866zm11.336-3.149a2.292 2.292 0 01-2.153 2.285h-.271a2.292 2.292 0 01-2.132-1.974v-.027a2.289 2.289 0 114.56-.283zm-5.662 5.014a2.3 2.3 0 012.257-1.866h2.24a2.3 2.3 0 012.257 1.866z"
        />
        <path
          data-name="Path 1043"
          d="M15.138 19.538a1.209 1.209 0 100-2.418h-1.033a1.209 1.209 0 100 2.418zm-1.381-1.209a.345.345 0 01.345-.345h1.036a.345.345 0 010 .69h-1.033a.345.345 0 01-.348-.345z"
        />
        <path
          data-name="Path 1044"
          d="M7.577 19.538h1.036a1.209 1.209 0 100-2.418H7.577a1.209 1.209 0 100 2.418zm0-1.554h1.036a.345.345 0 110 .69H7.577a.345.345 0 110-.69z"
        />
        <path
          data-name="Path 1045"
          d="M21.664 19.538a1.209 1.209 0 100-2.418h-1.036a1.209 1.209 0 100 2.418zm-1.381-1.209a.345.345 0 01.345-.345h1.036a.345.345 0 110 .69h-1.036a.345.345 0 01-.345-.345z"
        />
      </g>
    </g>
  </svg>
);

SvgTeachingEducationAndTraining.defaultProps = {};
export default SvgTeachingEducationAndTraining;
/* eslint-enable */
